import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
  Spinner,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";
import { MultiSelect } from "react-multi-select-component";

const AddEditUniversitySubject = (props) => {
  const navigate = useNavigate();
  const { id, subjectId } = useParams();
  const [isSaving, setIsSaving] = useState(true);
  const [isImageUploading, setIsImageUploading] = useState(false);

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;
  const [optionsSubjects, setOptionsSubjects] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [result, setResult] = useState("");
  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    let responseSubjects = "";
    let responseItem = "";

    try {
      responseSubjects = await axios.get(`/subjects`);
      setOptionsSubjects(
        responseSubjects.data.data.data.map((item, index) => {
          return {
            label: item?.name && getFirstNonNullValue(item.name),
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }

    try {
      responseItem = await axios.get(`/subjects?filter[universities.id]=${id}`);
      console.log(responseItem.data.data.data);
      responseItem?.data?.data?.data?.length &&
        setSelectedSubjects(
          responseItem?.data?.data?.data?.map((item, index) => {
            return {
              label: getFirstNonNullValue(item.name),
              value: String(item.id),
            };
          })
        );

      setIsSaving(false);
    } catch (error) {
      console.log(error);
    }
  }
  return (
    <Page
      title={`Subjects`}
      backAction={{
        onAction: () => navigate(`/admin/universities`),
      }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      {/* <Card sectioned> */}
      <FormLayout>
        {/* <Text>Subjects</Text> */}

        <div
          style={{
            position: "relative",
            zIndex: 9999,
            // marginBottom: "400px",
          }}
        >
          <MultiSelect
            options={optionsSubjects}
            onChange={setSelectedSubjects}
            value={selectedSubjects}
            placeholder="Please select"
          />
        </div>
      </FormLayout>

      <PageActions
        primaryAction={
          <Button variant="primary" onClick={handleSave}>
            {isSaving ? <Spinner size="small" /> : "Save"}
          </Button>
        }
      />
      {/* </Card> */}
      {/* <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => {
                setIsSaving(true);
                axios
                  .delete(`/subjects/${subjectId}`)
                  .then((result) => {
                    navigate(`/admin/universities/${id}/subjects`);
                  })
                  .catch((err) => console.log(err));
              }}
            >
              Delete
            </Button>
          )
        }
      /> */}
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    setIsSaving(true);
    const form_data = new FormData();
    selectedSubjects.forEach((selectedSubject, index) =>
      form_data.append(`subject_ids[${index}]`, selectedSubject.value)
    );
    form_data.append("_method", "PATCH");
    axios
      .post(`/universities/${id}/subjects`, form_data)
      .then((result) => {
        navigate(`/admin/universities`);
      })
      .catch((err) => console.log(err));
  }
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default AddEditUniversitySubject;
